import React from 'react';

import useEvents, {
  INormalizedEvent,
  useExtendedEventType,
} from '../utils/useEvents';
import getEntityLink from '../utils/getEntityLink';

import CountryFlag from 'components/base/CountryFlag';
import { ReactComponent as regionIcon } from 'icons/icon-region.svg';
import { FlagImage } from 'components/base/TopicFiltersDropdown/RegionDropdown/index';
import Span from 'components/elements/span';

import { Link, ListItem, Meta, Button } from '../styles';
import { IEvent } from '../types';

const UnreadEventsList: React.FC<IProps> = (props) => {
  const {
    events,
    countries,
    setDetailPageEntityId,
    handleAcknowledgeEvent,
    regions,
  } = props;

  const limit = 5;
  const artistId = events?.[0]?.relatedEntity?.id;
  const extendedEvents = useExtendedEventType(events);
  const normalizedEvents = useEvents(extendedEvents, countries, regions);
  if (!events || !normalizedEvents || !artistId) return null;

  return (
    <ul>
      {normalizedEvents
        .filter((_, index: number) => index < limit)
        .map((event: INormalizedEvent) => {
          const {
            eventMessage,
            date,
            country,
            entity,
            relatedEntity,
            eventType,
          } = event;
          const { type, id } = entity;

          return (
            <ListItem withBullet key={event.id}>
              <Link
                onClick={(): void => handleAcknowledgeEvent(event.id)}
                to={getEntityLink(type, id, relatedEntity.id, eventType)}
              >
                {eventMessage}
              </Link>
              <Meta>
                {date} &#8226;{' '}
                {country?.id.startsWith('RE-') ? (
                  <FlagImage as={regionIcon} width={19} height={19} />
                ) : (
                  <CountryFlag small {...country} />
                )}
                {country?.displayName} &#8226; {event.eventTypeCategory}{' '}
                {event?.eventTypeSubCategory ? (
                  <>
                    <Span mx={2} fontWeight="600">
                      &middot;
                    </Span>
                    <span>{event?.eventTypeSubCategory}</span>
                  </>
                ) : null}
              </Meta>
            </ListItem>
          );
        })}

      {events.length > limit && (
        <ListItem>
          <Button
            type="button"
            onClick={(event: MouseEvent): void => {
              event.stopPropagation();
              setDetailPageEntityId(artistId);
            }}
          >
            and {events.length - limit} more unread notifications...
          </Button>
        </ListItem>
      )}
    </ul>
  );
};

interface IProps {
  events?: Array<IEvent>;
  countries: any[];
  setDetailPageEntityId: (entityId: string) => void;
  handleAcknowledgeEvent: (entityId: number) => void;
  regions: any[];
}

export default UnreadEventsList;
